import {
  USER_AUTHENTICATE_SUCCESS,
  USER_AUTHENTICATE_FAILURE,
  USER_AUTHENTICATE_START,
  SSO_AUTHENTICATE_START,
  SSO_AUTHENTICATE_SUCCESS,
  SSO_NOT_AVAILABLE,
  LOGOUT,
  GET_TOKEN_SUCCESS,
  SSO_AUTHENTICATE_FAILURE,
  SET_BXAUTH_VALIDATED,
  SET_IS_BX_CURRENCY_CULTURE,
  SET_AADVANTAGE_NUMBER,
  SET_DEEP_LINK,
  CLEAR_DEEP_LINK,
} from '../actions/auth';
import { USER_IMAGE_UPDATE } from '../actions/profile';

const initialState = {
  tokenData: null,
  user: null,
  isSso: true,
  loginLoading: false,
  isBXCurrencyCulture: false,
  url: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TOKEN_SUCCESS:
      return {
        ...state,
        tokenData: action.tokenData,
      };
    case USER_AUTHENTICATE_START:
      return {
        ...state,
        loginLoading: true,
      };
    case SSO_AUTHENTICATE_START:
      return {
        ...state,
        loginLoading: true,
      };
    case SSO_AUTHENTICATE_SUCCESS:
      return {
        ...state,
        loginLoading: false,
        isSso: true,
      };
    case SSO_NOT_AVAILABLE:
      return {
        ...state,
        loginLoading: false,
        isSso: false,
      };
    case SSO_AUTHENTICATE_FAILURE:
      return {
        ...state,
        loginLoading: false,
        isSso: false,
      };
    case USER_AUTHENTICATE_SUCCESS:
      return {
        ...state,
        user: action.user,
        loginLoading: false,
      };
    case USER_IMAGE_UPDATE:
      return {
        ...state,
        user: {
          ...state.user,
          ImageUrl: action.imageUrl,
        },
      };
    case USER_AUTHENTICATE_FAILURE:
      return {
        ...state,
        loginLoading: false,
      };
    case LOGOUT:
      return {
        ...initialState,
      };
    case SET_IS_BX_CURRENCY_CULTURE:
      return { ...state, isBXCurrencyCulture: action.isBXCurrencyCulture };
    case SET_BXAUTH_VALIDATED:
      return {
        ...state,
        bxAuthSuccess: action.bxAuthSuccess,
      };
    case SET_AADVANTAGE_NUMBER:
      return {
        ...state,
        aadvantageNumber: action.data,
      };

    case SET_DEEP_LINK:
      return {
        ...state,
        url: action.payload,
        timestamp: Date.now(),
      };
    case CLEAR_DEEP_LINK:
      return {
        ...state,
        url: null,
      };
    default:
      return state;
  }
};
